import { render, staticRenderFns } from "./createDialog.vue?vue&type=template&id=65109428&scoped=true"
import script from "./createDialog.vue?vue&type=script&lang=ts"
export * from "./createDialog.vue?vue&type=script&lang=ts"
import style0 from "./createDialog.vue?vue&type=style&index=0&id=65109428&prod&lang=scss"
import style1 from "./createDialog.vue?vue&type=style&index=1&id=65109428&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65109428",
  null
  
)

export default component.exports